var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 60,
    cy: 60,
    r: 50,
    fill: "#FB3352"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 35C57.2386 35 55 37.2386 55 40C55 42.7614 57.2386 45 60 45C62.7614 45 65 42.7614 65 40C65 37.2386 62.7614 35 60 35ZM60 55C57.2386 55 55 57.2386 55 60V80C55 82.7614 57.2386 85 60 85C62.7614 85 65 82.7614 65 80V60C65 57.2386 62.7614 55 60 55Z",
    fill: "#FB3352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/Icon_error.cbfaa37366537817fed10723afff5b27.svg";
export { ForwardRef as ReactComponent };